module.exports = __webpack_public_path__ + "static/media/svv-logo-hvit.4aabc512.svg";